import queryString from 'query-string';

import { apiUrl, cancellableRequest } from 'src/services/api.js';
import { createObjectMapper } from 'src/utils/object.js';

const paramsMap = {
  qualification: 'qualification_id',
  qualifications: 'qids',
  hubs: 'hub_ids',
  locations: 'city_ids',
  companies: 'company_ids',
  onlyContributedHubs: 'invests_only',
  excludeLocations: 'not_cities',
  excludeCompanies: 'not_companies',
  activityPeriod: 'activity_period',
  salaryFrom: 'salary_from',
  salaryTo: 'salary_to',
  hasSalary: 'with_salary',
};

const mapLocationParams = createObjectMapper({
  filterEmpty: true,
  defaults: {
    currency: 'RUR',
  },
  map: paramsMap,
});

const mapRequestParams = createObjectMapper({
  filterEmpty: true,
  map: paramsMap,
});

export const HabrResumesService = {
  getList(params) {
    return cancellableRequest({
      method: 'get',
      url: `${apiUrl}/habr_resumes`,
      params: mapRequestParams(params),
    });
  },
  getMappedParams(params) {
    return mapLocationParams(params);
  },
  syncLocation(params) {
    const mappedParams = mapLocationParams(params);
    const urlQuery = queryString.stringify(mappedParams,{ arrayFormat: 'bracket' });
    const newUrl = `${window.location.pathname}${urlQuery.length ? '?' : ''}${urlQuery}`;
    window.history.replaceState(params, window.location.title, newUrl);
  }
};
